import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 2.49998L6.5 8.49998",
			stroke: "black",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 18.5L6.5 22.5",
			stroke: "black",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 14.5C10 12.567 8.433 11 6.5 11C4.567 11 3 12.567 3 14.5C3 16.433 4.567 18 6.5 18C8.433 18 10 16.433 10 14.5Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5 2.49998L17.5 6.49998",
			stroke: "black",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5 16.5L17.5 22.5",
			stroke: "black",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 10.5C21 8.56699 19.433 6.99998 17.5 6.99998C15.567 6.99998 14 8.56699 14 10.5C14 12.433 15.567 14 17.5 14C19.433 14 21 12.433 21 10.5Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFilter;
